import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30,
  },
  path: {
    fill: '#FFDB00',
    fillRule: 'evenodd',
    strokeWidth: '0px',
  },
});

const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns=" http://www.w3.org/2000/svg"
      viewBox="0 0 13.32 24.75"
    >
      <g>
        <path
          className={classes.path}
          d="M7.48,17.74L1.71,11.96C-.57,9.68-.57,5.99,1.71,3.71L5.42,0l4.12,4.12-3.71,3.71,5.77,5.77c2.28,2.28,2.28,5.97,0,8.25l-2.89,2.89-4.13-4.12,2.89-2.89ZM8.72,19.8l.41-.41c.91-.91.91-2.39,0-3.3l-5.77-5.77c-1.37-1.37-1.37-3.58,0-4.95l1.24-1.24.82.82-1.24,1.24c-.91.91-.91,2.39,0,3.3l5.77,5.77c1.37,1.37,1.37,3.58,0,4.95l-.41.41-.82-.82Z"
        />
      </g>
    </svg>
  );
};

export default LogoIcon;
